import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { Router } from "@angular/router";
import { AuthService } from "../shared/services/auth";
import { ToastrService } from "ngx-toastr";
import { LoginResponse } from "../shared/interfaces/user.interface";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
})
export class LoginComponent {
  loginForm: FormGroup;
  hide = true;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private notification: ToastrService,
     private spinnerSvc: NgxSpinnerService
  ) {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", Validators.required],
    });

  }

  ngOnInit(): void {
    sessionStorage.clear();
  }

  onSubmit() {
  if (this.loginForm.valid) {
    this.spinnerSvc.show();
    this.authService
      .loginMe(this.loginForm.value.email, this.loginForm.value.password)
      .subscribe({
        next: (response: LoginResponse) => {
          sessionStorage.setItem("auth", JSON.stringify(response));
          this.spinnerSvc.hide();
          this.router.navigate(["/updatePrice"]);
        },
        error: (error) => {
          this.notification.error("Login failed", error?.message|| error?.statusText);
          this.spinnerSvc.hide();
        },
      });
  } else {
    this.notification.error("Login failed", "Invalid email or password");
  }
  this.spinnerSvc.hide();
}

}
